export default "__VITE_ASSET__cCLPAqcO__"